<template lang='pug'>
#modal-selecionar-cars-sobrepostos
        el-dialog(
            :visible.sync='show',
            :title="$t('mensagens.territorio.territorioVegaSobreposto.titulo')",
            :close-on-click-modal='false',
            :close-on-press-escape='false',
            :destroy-on-close='true',
            :show-close='false',
            width='85%'
        )
            main
                .mensagem
                    p
                        | {{ $t('mensagens.territorio.territorioVegaSobreposto.foiEncontradaSobreposicao') }}
                        br
                        | {{ $t('mensagens.territorio.territorioVegaSobreposto.incorporarGeometriaDoTerritorioVega') }}

                .mapa
                    mapa(
                        :mapLayersConfigs='mapLayersConfigs',
                        :mapConfig='mapConfig',
                        height='100%',
                        idMapa='mapaListTerritoriosVega',
                        @is-ready='fitMapBounds',
                        ref='mapa'
                    )

                .cars-sobrepostos
                    .lista
                        .car-sobreposto(
                            v-for='territorioVega in territoriosVegaSoprepostos',
                            @mouseover='highlightTerritorio = territorioVega.codigo',
                            @mouseleave='highlightTerritorio = ``'
                        )
                            el-radio(
                                v-model='territorioSelecionado',
                                :label='territorioVega',
                                :key='territorioVega.codigo'
                            )
                                | {{ territorioVega.codigo }}

            footer.my-3(slot='footer')
                BaseButton(
                    @click='mostrarModalConfirmacaoVoltar = true',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.voltar') }}

                BaseButton(
                    type='primary',
                    size='mini'
                    @click='salvar'
                )
                    | {{ $t('mensagens.comuns.salvar') }}

        el-dialog.voltar(
            :visible.sync='mostrarModalConfirmacaoVoltar',
            :title="$t('mensagens.territorio.territorioVegaSobreposto.naoIncorporarGeometriaModalTitulo')",
            :destroy-on-close='true',
            :show-close='false',
            width='30%',
            append-to-body
        )
            footer.voltar__footer
                BaseButton(
                    @click='mostrarModalConfirmacaoVoltar = false',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.cancelar') }}
                BaseButton(
                    type='primary',
                    @click='fecharModalDeSobreposicao',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.prosseguir') }}

        .cars-vinculados
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapGetters } from 'vuex';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalSelecionarTerritorioVegaSobreposto',

    components: {
        Mapa,
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },

        cars: {
            type: Array,
            required: false
        },

        geometriaTerritorio: {
            type: Object,
            required: false
        },

        firstCars: {
            type: Array,
            required: false
        },

        carEspecificado: {
            type: Boolean,
            default: false
        },

        territoriosVegaSoprepostos: {
            type: Array,
            required: false
        }
    },

    emits: ['voltar', 'salvar', 'ignorar-todos'],

    data() {
        return {
            mapLayersConfigs: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                }
            },
            highlightTerritorio: '',
            highlightCARAtivo: '',
            geometriasCAR: {},
            carsVinculados: [],
            mostrarModalConfirmacaoVoltar: false,
            carsSelecionados: [],
            territorioSelecionado: null
        };
    },

    created() {
        this.configureLayersMapa();
        if (this.territoriosVegaSoprepostos) {
            this.territorioSelecionado = this.territoriosVegaSoprepostos[0];
        }
    },

    watch: {
        highlightTerritorio: function() {
            if (this.highlightTerritorio === '') {
                this.mapLayersConfigs = this.mapLayersConfigs.filter(
                    ({ name }) => name !== `highlight_${this.highlightCARAtivo}`
                );
            } else {
                this.highlightCARAtivo = this.highlightTerritorio;
                const geometriaTerritorioSelecionado = this.territoriosVegaSoprepostos.find(t => t.codigo === this.highlightTerritorio).geom;
                this.mapLayersConfigs.push({
                    style: getEstiloGeometria('carHighlight'),
                    name: `highlight_${this.highlightTerritorio}`,
                    geoJson: geometriaTerritorioSelecionado
                });
            }
        },

        geometriaTerritorio: function() {
            this.configureLayersMapa();
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        configureLayersMapa() {
            this.mapLayersConfigs = [];
            this.carsVinculados = this.firstCars;

            this.territoriosVegaSoprepostos.forEach(territorioVega => {
                this.mapLayersConfigs.push({
                    style: getEstiloGeometria('car'),
                    name: territorioVega.codigo,
                    geoJson: territorioVega.geom
                });
            });

            this.mapLayersConfigs.push({
                style: getEstiloGeometria('area'),
                name: 'Geometria territorio',
                geoJson: this.geometriaTerritorio
            });
        },

        limparMapa() {
            this.mapLayersConfigs = [];

            this.mapLayersConfigs.push({
                style: getEstiloGeometria('area'),
                name: 'Geometria territorio',
                geoJson: this.geometriaTerritorio
            });
        },

        ignorarCAR(car) {
            this.cars.splice(this.cars.indexOf(car), 1);
            this.mapLayersConfigs = this.mapLayersConfigs.filter(
                ({ name }) => name !== car
            );
        },

        ignorarTodos() {
            this.limparMapa();
            this.cars = [];
            if (this.carsVinculados.length === 0) {
                this.$emit('ignorar-todos', this.geometriaTerritorio);
            }
        },

        vincularCAR(car) {
            this.cars.splice(this.cars.indexOf(car), 1);
            this.carsVinculados.push(car);

            this.mapLayersConfigs = this.mapLayersConfigs.filter(
                ({ name }) => name !== car
            );
        },

        vincularTodos() {
            this.limparMapa();

            this.carsVinculados = [...this.carsVinculados, ...this.cars];
            this.cars = [];
        },

        fecharModalDeSobreposicao() {
            this.mostrarModalConfirmacaoVoltar = false;
            this.$emit('voltar');
        },

        salvar() {
            this.$emit('salvar', this.territorioSelecionado);
        },

        changeCheckbox(carSelecionado, car) {
            if (carSelecionado) {
                this.carsSelecionados.push(car);
            } else {
                this.carsSelecionados.splice(
                    this.carsSelecionados.indexOf(car),
                    1
                );
            }
        },

        vincularSelecionados() {
            this.carsSelecionados.forEach(car => this.vincularCAR(car));
            this.carsSelecionados = [];
        },

        ignorarSelecionados() {
            this.carsSelecionados.forEach(car => this.ignorarCAR(car));
            this.carsSelecionados = [];
        },

        fitMapBounds(mapa) {
            setTimeout(() => {
                const bounds = L.geoJSON(this.geometriaTerritorio).getBounds();
                mapa.fitBounds(bounds);
            }, 400);
        }
    }
};
</script>

<style lang='scss' scoped>
#modal-selecionar-cars-sobrepostos {
    main {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            'mensagem mensagem'
            'mapa cars-sobrepostos'
            'cars-vinculados cars-vinculados';
    }

    .mensagem {
        grid-area: mensagem;
    }

    .mapa {
        grid-area: mapa;

        height: 400px;
        overflow: hidden;
        border-radius: 4px 0 0 4px;
    }

    .list-select-cars {
        grid-area: list-select-cars;

        .lista-cars {
            @include scroll-bar();
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            max-height: 200px;
            overflow: auto;
            border-bottom: 1px solid var(--gray);

            span {
                font-size: 12px;
                width: 350px;
            }
        }
    }

    .cars-sobrepostos {
        grid-area: cars-sobrepostos;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 400px;
        overflow: auto;

        border-radius: 0 4px 4px 0;
        border: 1px solid var(--gray);
        padding: 16px;

        .lista {
            @include scroll-bar();
            overflow: auto;
            border-bottom: 1px solid grey;
            min-height: 323px;

            .car-sobreposto {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 8px;
                border-radius: 2px;
                margin-bottom: 4px;

                .acoes {
                    i {
                        font-size: 15px;
                    }
                }
            }

            .car-sobreposto:hover {
                background-color: var(--default-background-color);
            }
        }
    }

    .cars-vinculados {
        grid-area: cars-vinculados;

        .lista-cars-vinculados {
            @include scroll-bar();
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            max-height: 200px;
            overflow: auto;
            border-bottom: 1px solid var(--gray);

            span {
                font-size: 12px;
                width: 350px;
            }
        }
    }

    footer {
        display: flex;
        justify-content: space-between;
    }
}

.el-checkbox {
    margin-bottom: 0 !important;
}

.voltar__footer {
    display: flex !important;
    justify-content: space-between !important;
}
</style>
